{
  "id": "campaign-078",
  "name": "Mossy Tee",
  "seed": "campaign:78",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "._.......,..",
    "._......,,,.",
    "._T.........",
    "._........**",
    "._.ooo...***",
    "._.oFoss..**",
    "._.ooo.ss...",
    "._..,.T.....",
    "._..#..T....",
    "._...T......",
    "._....T...h.",
    "._.W........",
    "._W...T....h",
    "._...h......",
    "._b.........",
    "._..*.....T.",
    "...***......",
    "....*.T....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 16
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 78,
  "biome": "golf",
  "par": {
    "reel": 6800,
    "push": 5911,
    "selfPropelled": 5478,
    "tractor": 4965,
    "zeroTurn": 3595,
    "fairway": 2378
  },
  "routeTries": {
    "par": {
      "reel": 12,
      "push": 22,
      "selfPropelled": 17,
      "tractor": 20,
      "zeroTurn": 8,
      "fairway": 11
    }
  }
}
